import { render, staticRenderFns } from "./InvestmentRegister.vue?vue&type=template&id=52efc5e9&"
import script from "./InvestmentRegister.vue?vue&type=script&lang=js&"
export * from "./InvestmentRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports